// @flow

import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import theme from 'styled-theming'

import { OuterContainer } from '../helpers/outer-container'
import route from '../../data/routes'
import { myTheme, themedTextColor, themedTextColorRgb } from '../../styles'

import Logo from '../logo'
import { Navigation, NavigationItem } from '../navigation'

// Styles
// ----------------------------------------

const {
  color, fontWeight, breakpoint, space, borderRadii,
} = myTheme

const linkColor = theme('mode', {
  light: color.text,
  dark: color.white,
})

// About Site
// ----------------------------------------

const SiteTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: ${fontWeight.four};
`
const StyledLink = styled(Link)`
  color: ${linkColor};
  text-decoration: none;

  @media screen and (min-width: ${breakpoint.medium}) {
    transition: background-color 150ms ease-in-out;
    border-radius: ${borderRadii.two};
    background-color: transparent;
    margin-left: -${space.one};
    padding: ${space.half} ${space.one};

    &:hover {
      color: ${themedTextColor};
      background-color: rgba(${themedTextColorRgb}, 0.1);
    }
  }
`

type Props = {
  title: string,
}

const Header = ({ title }: Props) => (
  <OuterContainer className="flex mb1 md-mb2 py3">
    <div>
      <div className="flex items-center">
        <SiteTitle className="m0">
          <StyledLink
            color="text"
            to={route.home}
          >
            {title}
          </StyledLink>
        </SiteTitle>
      </div>
      <Navigation>
        <NavigationItem to={route.about}>About</NavigationItem>
        <NavigationItem to={route.works}>Works</NavigationItem>
        <NavigationItem to={route.writing}>Writing</NavigationItem>
      </Navigation>
    </div>
    <div className="ml-auto">
      <Link to={route.home}>
        <Logo />
      </Link>
    </div>
  </OuterContainer>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header/header.js